import { commitMutation, graphql } from 'react-relay';

const mutation = graphql`
  mutation AdyenPaymentsDetailsMutation($input: AdyenPaymentsDetailsInput!) {
    adyenPaymentsDetails(input: $input) {
      paymentsDetails {
        merchantReference,
        pspReference,
        resultCode
      }
    }
  }
`;

function commit(environment, details, callback) {
  return commitMutation(environment, {
    mutation,
    variables: {
      input: {
        details,
      },
    },
    onCompleted: (response, errors) => {
      if (errors) {
        callback && callback(errors[0]);
      } else {
        callback && callback(null, response.adyenPaymentsDetails.paymentsDetails)
      }
    },
    onError: err => {
      callback && callback(err);
    },
  });
}

export default { commit };
